module.exports = __webpack_public_path__ + "img/hal-gatewood-tZc3vjPCk-Q-unsplash.9c9545f3.jpg";